module.exports = __webpack_public_path__ + "static/img/IR.e995958d.png";